import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { normalizeEscapedWhitespace } from 'src/utils/CommonUtils';

interface MarkdownContentProps {
	content?: string | null;
}

/**
 * Renders markdown content (with escaped whitespace normalized) as regular
 * inline content, without any code-block styling.
 */
export const MarkdownContent: React.FC<MarkdownContentProps> = ({ content }) => (
	<ReactMarkdown remarkPlugins={[remarkGfm]}>
		{normalizeEscapedWhitespace(content ?? '')}
	</ReactMarkdown>
);

export default MarkdownContent;
